import React from 'react';
import { Icon } from './Icon.js';
export const IconCalculator3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m15.25,8.25H2.75c-.4141,0-.75.3359-.75.75s.3359.75.75.75h12.5c.4141,0,.75-.3359.75-.75s-.3359-.75-.75-.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "9", cy: "4", r: "2.5", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "14", r: "2.5", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCalculator3Fill18.js.map